import * as GeneratePassword from 'generate-password';

/**
 * Set global so you don't have to import it
 */
window.GeneratePassword = GeneratePassword;
